import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PublicDataService } from 'src/app/core/services';
import { DataUser } from 'src/app/utils/models';
import { EncryptService } from '../../../core/services/encrypt/encrypt.service';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent implements OnInit {
  currentLanguage: string;
  isOpenLanguage: boolean;
  isProfile: boolean = false;
  defaultLanguage: 'es' | 'en';
  isDashboard: boolean;
  sesionAbierta: boolean = false;
  esLogin: boolean = false;

  constructor(
    public translate: TranslateService,
    private readonly publicData: PublicDataService,
    private readonly router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
    private encrypt: EncryptService
  ) {
    this.currentLanguage = '';
    this.isOpenLanguage = false;
    this.defaultLanguage = 'es';
    this.isDashboard = false;
  }

  ngOnInit(): void {
    const dataUser =
      this.encrypt.getSession() !== ''
        ? this.encrypt.getSession()
        : new DataUser();

    this.router.events.subscribe((response: any) => {
      if (response && response.url && response.url == ('/')) {
        this.esLogin = true;
      }

      if (response && response.url && response.url.includes('/panel')) {
        return;
      }

      if (
        response &&
        response.url &&
        !response.url.includes('/dashboard') &&
        response.url !== '/'
      ) {
        // this.publicData.getDefaultLanguage(response.url.slice(1)).subscribe((response: any) => {
        //     if (response) {
        //       if (isPlatformBrowser(this.platformId)) {
        //         localStorage.removeItem('language');
        //         localStorage.setItem('language', response.idioma);
        //         this.publicData.idioma =
        //           response.idioma === 'es' ? 'esp' : 'eng';
        //         this.translate.use(response.idioma);
        //         this.currentLanguage = response.idioma;
        //       }
        //     }
        //   });
      }

      if (response && response.url) {
        this.isDashboard = response.url.includes('/dashboard') ? true : false;

        this.isProfile = response.url === '/dashboard/profile' ? true : false;
        const alias = response.url.includes('/dashboard')
          ? dataUser.idUsuario
          : response.url.slice(1);
        // this.getLanguageDefault(alias);
      }
    });
    this.currentLanguage = this.publicData.idioma === 'esp' ? 'es' : 'en';

    this.sesionAbierta = this.validateSession();
  }

  changeLanguage(language: MatRadioChange): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('language');
      localStorage.setItem('language', language.value);
      this.publicData.idioma = language.value === 'es' ? 'esp' : 'eng';
      this.translate.use(language.value);
      this.currentLanguage = language.value;
    }
  }

  changeLanguageDefault(language: MatRadioChange): void {
    const dataUser =
      this.encrypt.getSession() !== ''
        ? this.encrypt.getSession()
        : new DataUser();

    this.publicData
      .updateDefaultLanguage(dataUser.idUsuario, language.value)
      .subscribe((response) => {});
  }

  private getLanguageDefault(aliasOrId: string | number): void {
    this.publicData.getDefaultLanguage(aliasOrId).subscribe((response: any) => {
      this.defaultLanguage = response.idioma;
    });
  }

  private validateSession(): boolean {
    let session = false;
    if (this.encrypt.getSession() !== '' && typeof this.encrypt.getSession().idUsuario === 'number') {
      session = true;
    }
    var diff = Math.abs(new Date(this.encrypt.getSession().FechaInicio).getTime() - new Date().getTime());
    var minutes = Math.floor(diff / 1000 / 60 / 60);
    if (minutes > 23) {
      session = false;
    }
    return session;
  }
}
